module.exports = __webpack_public_path__ + "static/media/minimize.40cb8a5b.png";